<template>
  <b-tooltip
    class="time-bar-container"
    type="is-dark"
    multilined
    v-if="timeData && timeData.duration > 0"
  >
    <div>
      <b-progress
        class="time-bar"
        size="is-small"
        :max="maxValue"
        style="height: 0.5rem !important"
      >
        <template #bar>
          <b-progress-bar :value="bar1Value" type="is-info"></b-progress-bar>
          <b-progress-bar :value="bar2Value" type="is-success"></b-progress-bar>
          <b-progress-bar :value="elapsedValue"></b-progress-bar>
        </template>
      </b-progress>
    </div>

    <template v-slot:content>
      <p>
        time:
        <b class="has-text-info">{{ bar1Value | asMmSs }}</b>
        / {{ timeData.duration / 60 }}m
        <i v-if="timeData.increment">(+{{ timeData.increment }}s)</i>
      </p>
      <p v-if="timeData.bufferDuration">
        buffer:
        <b class="has-text-success">{{ bar2Value | asMmSs }}</b>
        / {{ timeData.bufferDuration }}s
      </p>
    </template>
  </b-tooltip>
</template>

<script>
const TIMER_INTERVAL = 250;

import { cachedTimeOffset } from "@/utils/firebase-helper";
import { toDateWithOffset, diffIn } from "vue-chess-shared/utils/date-helper";

export default {
  name: "GameTimeBar",

  props: {
    timeData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      timeLeft: null,
    };
  },

  computed: {
    bar1Value() {
      return Math.max(0, this.timeLeft || 0);
    },

    bar2Value() {
      return Math.max(0, this.timeData.bufferLeft || 0);
    },

    maxValue() {
      return this.timeData.totalTime + this.timeData.bufferDuration;
    },

    elapsedValue() {
      return this.maxValue - this.bar1Value - this.bar2Value;
    },
  },

  mounted() {
    this.timerId = setInterval(() => {
      if (!this.timeData) {
        return;
      }

      if (this.timeLeft === null) {
        this.timeLeft = this.timeData.timeLeft;
      }

      if (!this.timeData.isNextColor || !this.timeData.shouldDeductTime) {
        this.timeLeft = this.timeData.timeLeft;
        this.moveTime = 0;
        return;
      }

      this.moveTime = diffIn(
        toDateWithOffset(cachedTimeOffset()),
        this.timeData.lastMoveTime,
        "second"
      );

      this.timeLeft = this.timeData.timeLeft - this.moveTime;
    }, TIMER_INTERVAL);
  },

  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId);
  },
};
</script>

<style scoped>
.time-bar-container {
  width: 100%;
}
.timer-bar {
  height: 0.5rem;
}
</style>
